<template>
  <div class="scoresOnly" id="score">
    <!-- DO NOT REMOVE WILL BREAK -->
    <!-- DO NOT REMOVE WILL BREAK -->
    <b-row class="title">
      <b-col cols="10">
        <div class="title main TournamentTitle" >
          <template v-if="home == true">
            <span class="reportWidget_title">
              <img src="https://assets.asiantour.com/asian-tour/2023/12/LiveLeaderboard.png" class="liveLeaderboard">  Live Leaderboard
            </span>
          </template>
          <template v-if="useName == 'N'">
            <template v-if="config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
              <template >
                <p :class="{WidgetStyle: home == true}">{{data.short_name}} <span v-if="home != true">- {{title}}</span></p>
              </template>
            </template>
            <template v-else>
              <p :class="{WidgetStyle: home == true}">{{data.short_name}}</p>
            </template>
          </template>
          <template v-else>
            <template v-if="config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
              <template >
                <p :class="{WidgetStyle: home == true}">{{data.full_name}} <span v-if="home != true">- {{title}}</span></p>
              </template>
            </template>
            <template v-else>
              <p :class="{WidgetStyle: home == true}">{{data.full_name}}</p>
            </template>
          </template>
          <p class="lastUpdate" v-if="home == false">
            <span v-if="home == false"><span v-if="data.pft_time !== ''">- Projected Finish Time - {{ data.pft_time }}</span></span>
            <span>
              Last Score Update {{ data.last_scores_update_date }}
              {{ data.last_scores_update_time }} - (Local Time)...
            </span>
          </p>
        </div>
      </b-col>
      <b-col :class="{HomeHide: home == true}">
        <!-- <div class="mt-3">Selected: <strong>{{ selected }}</strong></div> -->
        <div class="sponLogo">
          <!-- <i v-b-toggle.collapse-1 class="fa-solid fa-circle-info"></i> -->
          <template v-if="config.VUE_APP_ID == 'bvt' || config.VUE_APP_TOUR == 'let' || config.VUE_APP_ID_ASIAN_TOUR == 'apga' || config.VUE_APP_ID_ADT == 'adt' || config.VUE_APP_ID == 'sst' || config.VUE_APP_ID == 'non'">
            <img class="informationImg" v-b-toggle="'collapse-1'" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2024/08/Information.png">
          </template>
          <template v-else>
            <i
              v-b-toggle="'collapse-1'"
              class="fa-solid fa-circle-info"
            ></i>
          </template>
        </div>
      </b-col>
    </b-row>
    <template v-if="show_info_web == 'Y'">
      <b-collapse id="collapse-1" class="mt-2 informationCLass" visible>
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
    <template v-else>
      <b-collapse id="collapse-1" class="mt-2 informationCLass">
        <Information
          :data="data"
          :showGender="showGender"
          :develop="develop"
          :title="title"
        />
      </b-collapse>
    </template>
    <div :class="{reportsHide: home == false}" class="gradHome"></div>
    <table class="scores-only-table" :class="{reportsHome : home == true}">
      <thead :class="{HomeHide: home == true}">
        <tr>
          <template
            v-if="
              (tablePick === 'Score' && data.match_play === 'N') ||
                (tablePick === 'Live' && data.match_play === 'N')
            "
          >
            <template v-if="showFav == 'W' || showFav == 'B' && data.match_play === 'N' && home === false">
              <th>
                Fav
              </th>
            </template>
            <th>
              Pos
            </th>
            <template
              v-if="data.live_oom !== '' && data.live_points_code !== '' && home == false"
            >
              <th class=" mobnone">
                OOM
              </th>
            </template>
            <th class="NameLeft">
              Name
            </th>
            <template v-if="tablePick === 'Live' || tablePick === 'Score'">
              <th class="mobnone" :class="{teamNat : title.includes('Team') && data.team_sb == 'Y'}">
                <span>Nat</span>
              </th>
            </template>
            <th v-if="data.score_type === 'P' || data.stableford === 'N'">
              <template v-if="data.team_sb == 'Y'">
                <span v-if="title.includes('Team') || tab == 'Y'">
                  Points
                </span>
                <span v-else>
                  Par
                </span>
              </template>
              <template v-else>
                Par
              </template>
            </th>
            <th v-if="data.score_type === 'P' || data.stableford === 'Y'">
              Points
            </th>
            <template
              v-if="title.includes('Scoreboard') && home === false"
            >
              <th
                v-for="(i, roundIt) in range(1, roundsPlayed)"
                :key="roundIt"
                class="hideOnMob"
                :class="{redPlayoff : data.playoff == 'Y'  && data.playoff_rounds['playoff_round_' + data.last_round_with_scores] == 'Y' &&
                      i == data.last_round_with_scores}"
              >
                <span v-if="roundsPlayed === 1 && tablePick === 'Score'">
                  Score
                </span>
                <span v-else>
                  <span
                    v-if="data.playoff == 'Y' && data.playoff_rounds['playoff_round_' + data.last_round_with_scores] == 'Y' &&
                      i == data.last_round_with_scores
                    "
                    >Playoff</span
                  >
                  <span v-else>R{{ i }}</span>
                </span>
              </th>
              <template v-if="data.team_sb == 'Y'">
                <template
                  v-if="
                    data.scores.scores_entry[0].score_found === 'Y' &&
                      stableford == 'N'
                  "
                >
                  <th v-if="roundsPlayed > 1">
                    Score
                  </th>
                </template>
                <template v-if="data.team_scores.team_scores_entry[0].score_found === 'Y' &&
                  stableford == 'N' && tab == 'Y'">
                    <th v-if="roundsPlayed > 1">
                      Score
                    </th>
                </template>
              </template>
              <template v-else>
                <template
                  v-if="
                    data.scores.scores_entry[0].score_found === 'Y' &&
                      stableford == 'N' 
                  "
                >
                  <th v-if="roundsPlayed > 1">
                    Score
                  </th>
                </template>
              </template>
              <!-- <template v-if="roundsPlayed > 1 && tablePick === 'Score'">
                <th
                  class="mobnone"
                  v-if="
                    config.VUE_APP_PLAYER_ICON === 'Y' &&
                      data.scores.scores_entry[0].score_found === 'Y' &&
                      data.last_round_complete === 'Y'
                  "
                ></th>
              </template> -->
            </template>
            <template v-if="data.team_sb == 'Y'">
              <template
                v-if="
                    data.round_head.includes('Scores')
                "
              >
                <th class="leftThru">
                  Thru 
                </th>
              </template>
              <template
                v-else-if="title.includes('Team')"
              >
                <th class="leftThru">
                  Thru
                </th>
              </template>
            </template>
            <template v-else>
              <template
                v-if="
                  data.scores.scores_entry[0].score_found === 'N' ||
                    data.round_head == 'Latest Scores'
                "
              >
                <th class="leftThru">
                  Thru
                </th>
              </template>
              <template
                v-else-if="data.scores_type == 'G' && data.scores.scores_entry[0].score_found === 'Y'"
              >
                <th class="leftThru">
                  
                </th>
              </template>
              <template
                v-else-if="data.scores_type == 'P' && data.scores.scores_entry[0].score_found === 'Y'"
              >
                <th class="leftThru" v-if="data.stableford_revised == 'Y'">
                  
                </th>
                <th class="leftThru" v-else>
                  Thru
                </th>
              </template>
              <template
                v-else
              >
                <th class="leftThru">
                  Score
                </th>
              </template>
            </template>
            <!-- <template
              v-if="
                this.title.includes('Only') ||
                  this.title.includes('Live') ||
                  tablePick === 'Live'
              "
            > -->
            <template v-if="home === false">
              <template v-if="tablePick === 'Live' || tablePick === 'Score'">
                <th class="mobnone">
                  <font-awesome-icon class="lock" :icon="['fa', 'user']" />
                </th>
              </template>
              <template v-else></template>
            </template>
          </template>
          <template
            v-if="
              (tablePick === 'Score' && data.match_play === 'Y') ||
                (tablePick === 'Live' && data.match_play === 'Y')
            "
          >
            <th>
              Name
            </th>
            <th>
              Score
            </th>
            <th>
              Thru.
            </th>
            <th>
              Score
            </th>
            <th>
              Name
            </th>
          </template>
        </tr>
      </thead>
      <tbody v-if="this.compare.length">
        <template>
          <tr
            v-for="(tabledata, index) in compare"
            @click.stop="rowClickedCompare(index)"
            :key="index"
            :class="{ drawNoborder: tablePick === 'Draw', homeTr: home == true }"
            class="compareRow"
          >
            <template
              v-if="
                (tablePick === 'Score' && data.match_play === 'N') ||
                  (tablePick === 'Live' && data.match_play === 'N')
              "
            >
              <template
                v-if="tabledata.member_no !== 'Cat' && tabledata.pos !== 'CUT'"
              >
                <td v-if="data.match_play === 'N' && home === false">
                  <b-form-checkbox
                    :id="tabledata.member_no"
                    v-model="compare"
                    :name="tabledata.member_no"
                    :value="tabledata"
                  >
                    <!-- <img class="favouriteStar" src="https://updated.sunshinetour.com/wp-content/uploads/2022/08/Favourite_Star_Grey@2x.png"> -->
                  </b-form-checkbox>
                </td>
              </template>
              <td class="cut" colspan="11" v-if="tabledata.pos === 'CUT'">
                {{ tabledata.cut_round }}
              </td>
              <td class="posnum" v-else-if="index !== 0" :class="{homeposnum : home == true}">
                <span class="homeposnum">
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td class="posnum" v-else-if="index === 0" :class="{homeposnum : home == true}">
                <span class="homeposnum">
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td v-else class="noPos"><span>.</span></td>
              <td
                v-if="
                  home == false &&
                    data.live_oom !== '' &&
                    data.live_points_code !== '' &&
                    tabledata.pos !== 'CUT'
                "
                class=""
              >
                <span
                  :class="{
                    Arrowup: tabledata.oom_diff_pos > 0,
                    Arrowdown: tabledata.oom_diff_pos < 0
                  }"
                  class="scores-pos"
                  v-if="
                    tabledata.oom_pos.length > 0 && tabledata.oom_pos !== '0'
                  "
                >
                  {{ tabledata.oom_pos }}
                  <font-awesome-icon
                    v-if="tabledata.oom_diff_pos > 0"
                    class="icon"
                    :icon="['fa', 'arrow-up']"
                  />
                  <font-awesome-icon
                    v-if="tabledata.oom_diff_pos < 0"
                    class="icon"
                    :icon="['fa', 'arrow-down']"
                  />
                </span>
              </td>
              <template v-if="home === true">
                <td
                  v-if="
                    tabledata.member_no !== 'Cat' &&
                      tabledata.pos !== 'CUT' &&
                      team === 'N'
                  "
                  :title="tabledata.member_no"
                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                  class="NameLeft"
                >
                  <!-- <a :href="'/playerprofile/' + tabledata.member_no"> -->
                  <span
                    v-if="data.score_type === 'P' || data.stableford === 'N'"
                    class="outerPlayerName"
                  >
                    <span
                      v-if="data.team_event === 'Y' || data.bball_team == 'Y'"
                      class="PlayerName"
                    >
                      {{ tabledata.name }}
                    </span>
                    <span v-else class="PlayerName">
                      <template v-if="home == true && config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
                        <template v-if="tabledata.profile == 'Y'">
                          <b-link :to="'/playerprofile/' + tabledata.member_no" class="removeUnderLineHome">
                            <span class="initialHome">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname.toLowerCase()}}</span>
                          </b-link>
                        </template>
                        <template v-else>
                          <span class="initialHomeNone">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname.toLowerCase()}}</span>
                        </template>
                      </template>
                      <template v-else>
                        {{ tabledata.name }}
                      </template>
                    </span>
                    <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                  </span>
                  <span
                    v-if="data.score_type === 'P' || data.stableford === 'Y'"
                    class="PlayerName"
                  >
                    {{ tabledata.name }}
                    <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                  </span>
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="sponsoredImage" :src="config.VUE_APP_TITLEIST"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y'"
                    ><b-img
                      style="width: 15px; margin-left: 13px;"
                      src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"
                    ></b-img
                  ></span>
                  <!-- </a> -->
                  <span
                    v-if="data.multi_course === 'Y' && home === false"
                    :class="tabledata['course_colour_R' + data.pft_round]"
                    class="multiDot-size-report"
                    >•</span
                  >
                  <span
                    v-if="showGender === 'Y' && home === false"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: tabledata.gender === 'F',
                      male: tabledata.gender === 'M'
                    }"
                    >•</span
                  >
                </td>
                <td
                  v-if="
                    tabledata.member_no !== 'Cat' &&
                      tabledata.pos !== 'CUT' &&
                      team === 'Y'
                  "
                  :title="tabledata.member_no"
                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                  class="NameLeft"
                >
                  {{ tabledata.name }}
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="sponsoredImage" :src="config.VUE_APP_TITLEIST"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y'"
                    ><b-img
                      style="width: 15px; margin-left: 13px;"
                      src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"
                    ></b-img
                  ></span>
                  <span
                    v-if="data.multi_course === 'Y' && home === false"
                    :class="tabledata['course_colour_R' + data.pft_round]"
                    class="multiDot-size-report"
                    >•</span
                  >
                  <span
                    v-if="showGender === 'Y' && home === false"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: tabledata.gender === 'F',
                      male: tabledata.gender === 'M'
                    }"
                    >•</span
                  >
                </td>
              </template>
              <template v-else>
                <td
                  v-if="
                    tabledata.member_no !== 'Cat' &&
                      tabledata.pos !== 'CUT' &&
                      team === 'N'
                  "
                  @click="playerCard(tabledata.id, index)"
                  :title="tabledata.member_no"
                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                  class="NameLeft"
                >
                  <!-- <a :href="'/playerprofile/' + tabledata.member_no"> -->
                  <span
                    v-if="data.score_type === 'P' || data.stableford === 'N'"
                    class="outerPlayerName"
                  >
                    <span
                      v-if="data.team_event === 'Y' || data.bball_team == 'Y'"
                      class="PlayerName"
                    >
                      {{ tabledata.name }}
                    </span>
                    <span v-else class="PlayerName">
                      <template v-if="home == true && config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
                        <template v-if="tabledata.profile == 'Y'">
                          <b-link :to="'/playerprofile/' + tabledata.member_no" class="removeUnderLineHome">
                            <span class="initialHome">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname.toLowerCase()}}</span>
                          </b-link>
                        </template>
                        <template v-else>
                          <span class="initialHomeNone">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname.toLowerCase()}}</span>
                        </template>
                      </template>
                      <template v-else>
                        {{ tabledata.name }}
                      </template>
                    </span>
                    <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                  </span>
                  <span
                    v-if="data.score_type === 'P' || data.stableford === 'Y'"
                  >
                    {{ tabledata.name }}
                    <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                  </span>
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="sponsoredImage" :src="config.VUE_APP_TITLEIST"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y'"
                    ><b-img
                      style="width: 15px; margin-left: 13px;"
                      src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"
                    ></b-img
                  ></span>
                  <!-- </a> -->
                  <span
                    v-if="data.multi_course === 'Y' && home === false"
                    :class="tabledata['course_colour_R' + data.pft_round]"
                    class="multiDot-size-report"
                    >•</span
                  >
                  <span
                    v-if="showGender === 'Y' && home === false"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: tabledata.gender === 'F',
                      male: tabledata.gender === 'M'
                    }"
                    >•</span
                  >
                </td>
                <td
                  v-if="
                    tabledata.member_no !== 'Cat' &&
                      tabledata.pos !== 'CUT' &&
                      team === 'Y'
                  "
                  @click="playerCard(tabledata.id, index)"
                  :title="tabledata.member_no"
                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                  class="NameLeft"
                >
                  {{ tabledata.name }}
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="sponsoredImage" :src="config.VUE_APP_TITLEIST"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y'"
                    ><b-img
                      style="width: 15px; margin-left: 13px;"
                      src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"
                    ></b-img
                  ></span>
                  <span
                    v-if="data.multi_course === 'Y' && home === false"
                    :class="tabledata['course_colour_R' + data.pft_round]"
                    class="multiDot-size-report"
                    >•</span
                  >
                  <span
                    v-if="showGender === 'Y' && home === false"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: tabledata.gender === 'F',
                      male: tabledata.gender === 'M'
                    }"
                    >•</span
                  >
                </td>
              </template>
              <template v-if="tablePick === 'Score' || tablePick === 'Live'">
                <td class="mobHide mobnone" v-if="tabledata.pos !== 'CUT'">
                  <span v-if="tabledata.nationality === ''"></span>
                  <span v-else>
                    <template v-if="data.represents_flag_type === 'N'">
                      {{ tabledata.nationality }}
                    </template>
                    <template v-else>
                      <img
                        class="flag"
                        :src="
                          (config.VUE_APP_FLAG_URL + tabledata.nationality)
                            | lowercase
                        "
                      />
                    </template>
                  </span>
                </td>
              </template>
              <template
                v-if="data.score_type === 'P' || data.stableford === 'N'"
              >
                <td v-if="tabledata.vspar < 0" class="up">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.vspar > 0" class="down">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.pos !== 'CUT'"
                  :class="{
                    nonScore: tabledata.vspar == 'RTD',
                    nonScoreone: tabledata.vspar == 'DSQ',
                    nonScoretwo: tabledata.score == 'WDN',
                    nonScorethree: tabledata.score == 'DSQ',
                    nonScorefour: tabledata.score == 'RTD'
                  }"
                >
                  {{ tabledata.vspar }}
                </td>
              </template>
              <template
                v-if="data.score_type === 'P' || data.stableford === 'Y'"
              >
                <td v-if="tabledata.pos !== 'CUT'">
                  {{ tabledata.score }}
                </td>
              </template>
              <template
                v-if="
                  title.includes('Scoreboard') &&
                    tabledata.pos !== 'CUT' &&
                    home === false
                "
              >
                <td
                  v-for="(i, roundIt) in range(1, roundsPlayed)"
                  :key="roundIt"
                  class="mobnone"
                  v-show="data.stableford === 'N'"
                >
                  <span
                    v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                    class="up"
                    >{{ tabledata.score }}</span
                  >
                  <span
                    v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                    class="down"
                    >{{ tabledata.score }}</span
                  >
                  <span v-else-if="roundsPlayed === 1">{{
                    tabledata.score
                  }}</span>
                  <span v-else-if="tabledata['vspar_R' + i] < 0" :class="up">{{
                    tabledata["score_R" + i]
                  }}</span>
                  <span
                    v-else-if="tabledata['vspar_R' + i] > 0"
                    :class="down"
                    >{{ tabledata["score_R" + i] }}</span
                  >
                  <span v-else
                    :class="{
                      nonScore: tabledata.vspar == 'RTD',
                      nonScoreone: tabledata.vspar == 'DSQ',
                      nonScoretwo: tabledata['score_R' + i] == 'WDN',
                      nonScorethree: tabledata['score_R' + i] == 'DSQ',
                      nonScorefour: tabledata['score_R' + i] == 'RTD'
                    }"
                  >{{ tabledata["score_R" + i] }}</span>
                </td>
                <template
                  v-if="tabledata.score_found === 'Y' && stableford == 'N'"
                >
                  <td v-if="tabledata.vspar < 0 && roundsPlayed > 1" class="up">
                    {{ tabledata.score }}
                  </td>
                  <td
                    v-else-if="tabledata.vspar > 0 && roundsPlayed > 1"
                    class="down"
                  >
                    {{ tabledata.score }}
                  </td>
                  <td v-else-if="roundsPlayed > 1">
                    {{ tabledata.score }} 
                  </td>
                </template>
              </template>
              <template
                v-if="
                  data.round_head == 'Latest Scores' ||
                    (tabledata.score_found == 'N' && tabledata.pos !== 'CUT')
                "
              >
                <td v-if="tabledata.pos !== 'CUT'" style="color: #6c6c6c;" :class="{thruColumn : home == false}">
                  <template
                    v-if="tabledata.holes && tabledata.holes.length > 0"
                  >
                    <span v-show="tabledata.holes != '18'">{{
                      tabledata.holes
                    }}</span>
                    <span v-show="tabledata.holes == '18'">F</span>
                  </template>
                  <template v-else>
                    <span v-if="tabledata['score_R' + data.pft_round] == 'RTD' && tabledata['score_R' + data.pft_round] == 'WDN' && tabledata['score_R' + data.pft_round] == 'DSQ'">
                      {{ tabledata["time_R" + data.pft_round] }}
                    </span>
                  </template>
                </td>
              </template>
              <template v-else>
                <td>
                  {{tabledata.score}}
                </td>
              </template>
              <template v-if="home === false">
                <td
                  class="mobnone"
                  v-if="
                    tabledata.member_no !== 'Cat' &&
                      tabledata.member_no !== 'EOF' &&
                      tabledata.pos !== 'CUT' &&
                      tablePick === 'Live' || tablePick === 'Score' 
                  "
                >
                  <template v-if="tabledata.profile == 'Y'">
                    <a
                      :href="'/playerprofile/' + tabledata.member_no"
                      target="_blank"
                    >
                      <span class="playerInfo">
                        <!-- Player Info -->
                        <span class="iconRight">
                          <font-awesome-icon
                            class="icon"
                            :icon="['fa', 'chevron-right']"
                          />
                        </span>
                      </span>
                    </a>
                  </template>
                </td>
              </template>
            </template>
            <template
              v-if="
                (tablePick === 'Score' && data.match_play === 'Y') ||
                  (tablePick === 'Final' && data.match_play === 'Y')
              "
            >
              <td
                :title="tabledata.member_no_1"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                  win: tabledata.status_1 == 'W'
                }"
              >
                {{ tabledata.initials_1 }} {{ tabledata.surname_1 }}
              </td>
              <td v-if="tabledata.status_1 === 'W'" class="win">
                {{ tabledata.full_score_1 }}
              </td>
              <td v-else></td>
              <td>
                <template
                  v-if="tabledata.holes && tabledata.holes.length > 0"
                >
                  <span class="mobLevel" v-show="tabledata.holes != '18'"
                    >{{ tabledata.holes }} 
                    <span v-if="tabledata['tee_R' + data.pft_round] > 1"
                      >*</span
                    >
                      <span v-if="data.rts[1] == 'S'" class="strokesColour">{{tabledata['strokes_R' + data.pft_round].split(",")[1]}}</span>
                    </span
                  >
                  <span v-show="tabledata.holes == '18'">F</span>
                </template>
                <template v-else>
                  {{ tabledata["time_R" + data.pft_round] }}
                </template>
              </td>
              <td v-if="tabledata.status_2 === 'W'" class="win">
                {{ tabledata.full_score_2 }}
              </td>
              <td v-else></td>
              <td
                :title="tabledata.member_no_2"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                  win: tabledata.status_2 == 'W'
                }"
              >
                {{ tabledata.initials_2 }} {{ tabledata.surname_2 }}
              </td>
            </template>
          </tr>
          <template v-if="hide_score_card == 'N'">
            <tr
              @click.stop="rowClickedCompare(rowClickedCompare === -1)"
              v-if="index === clickedRowCompare"
              class="tr-kids"
              :key="index + Math.random()"
            >
              <td id="reportCards" colspan="11">
                <PlayerReportCard
                  :playerData="playerData"
                  :playerDataTeam="playerDataTeam"
                  :data="data"
                  :config="config"
                  :actualRound="data.pft_round"
                  :roundsPlayed="data.pft_round"
                  :scoreType="data.scores_type"
                  :team="team"
                  :courses="courses"
                  :pointsOn="data.scores_type"
                />
              </td>
            </tr>
          </template>
        </template>
      </tbody>
      <tbody>
        <template v-for="(tabledata, index) in Eds">
          <tr
          :key="index"
            @click.stop="rowClicked(index)"
            :class="{ drawNoborder: tablePick === 'Draw', homeTr: home == true }"
          >
            <template
              v-if="
                (tablePick === 'Score' && data.match_play === 'N') ||
                  (tablePick === 'Live' && data.match_play === 'N')
              "
            >
              <template
                v-if="tabledata.member_no !== 'Cat' && tabledata.pos !== 'CUT'"
              >
                <td v-if="showFav == 'W' || showFav == 'B' && data.match_play === 'N' && home === false">
                  <template v-if="fanloggedIn == 'Y'">
                    <span @click.stop="saveFav(tabledata.member_no)">
                      <b-form-checkbox
                        :id="tabledata.member_no"
                        v-model="compare"
                        :name="tabledata.member_no"
                        :value="tabledata"
                      >
                        <!-- <img class="favouriteStar" src="https://updated.sunshinetour.com/wp-content/uploads/2022/08/Favourite_Star_Grey@2x.png"> -->
                      </b-form-checkbox>
                    </span>
                  </template>
                  <template v-else>
                    <b-form-checkbox
                      :id="tabledata.member_no"
                      v-model="compare"
                      :name="tabledata.member_no"
                      :value="tabledata"
                      class="non"
                    >
                      <!-- <img class="favouriteStar" src="https://updated.sunshinetour.com/wp-content/uploads/2022/08/Favourite_Star_Grey@2x.png"> -->
                    </b-form-checkbox>
                  </template>
                </td>
              </template>
              <td class="cut" colspan="11" v-if="tabledata.pos === 'CUT'">
                {{ tabledata.cut_round }}
              </td>
              <td class="posnum" v-else-if="index !== 0" :class="{homeposnum : home == true}">
                <span class="homeposnum">
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td class="posnum" v-else-if="index === 0" :class="{homeposnum : home == true}">
                <span class="homeposnum">
                  {{ tabledata.tied + tabledata.pos }}
                </span>
              </td>
              <td v-else class="noPos"><span>.</span></td>
              <td
                v-if="
                  home == false &&
                    data.live_oom !== '' &&
                    data.live_points_code !== '' &&
                    tabledata.pos !== 'CUT'
                "
                class=""
              >
                <span
                  :class="{
                    Arrowup: tabledata.oom_diff_pos > 0,
                    Arrowdown: tabledata.oom_diff_pos < 0
                  }"
                  class="scores-pos"
                  v-if="
                    tabledata.oom_pos.length > 0 && tabledata.oom_pos !== '0'
                  "
                >
                  {{ tabledata.oom_pos }}
                  <font-awesome-icon
                    v-if="tabledata.oom_diff_pos > 0"
                    class="icon"
                    :icon="['fa', 'arrow-up']"
                  />
                  <font-awesome-icon
                    v-if="tabledata.oom_diff_pos < 0"
                    class="icon"
                    :icon="['fa', 'arrow-down']"
                  />
                </span>
              </td>
              <template v-if="home === true">
                <td
                  v-if="
                    tabledata.member_no !== 'Cat' &&
                      tabledata.pos !== 'CUT' &&
                      team === 'N'
                  "

                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                  class="NameLeft"
                >
                  <!-- <a :href="'/playerprofile/' + tabledata.member_no"> -->
                  <span
                    v-if="data.score_type === 'P' || data.stableford === 'N'"
                    class="outerPlayerName"
                  >
                    <span
                      class="PlayerName"
                      v-if="data.team_event === 'Y' || data.bball_team == 'Y'"
                    >
                      {{ tabledata.name }}
                    </span>
                    <span v-else class="PlayerName">
                      <template v-if="home == true && config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
                        <template v-if="tabledata.profile == 'Y'">
                          <b-link :to="'/playerprofile/' + tabledata.member_no" class="removeUnderLineHome">
                            <span class="initialHome">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname.toLowerCase()}}</span>
                          </b-link>
                        </template>
                        <template v-else>
                          <span class="initialHomeNone">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname.toLowerCase()}}</span>
                        </template>
                      </template>
                      <template v-else>
                        {{ tabledata.name }}
                      </template>
                    </span>
                    <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                  </span>
                  <span
                    v-if="data.score_type === 'P' || data.stableford === 'Y'"
                    class="PlayerName"
                  >
                    {{ tabledata.name }}
                    <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                  </span>
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="sponsoredImage" :src="config.VUE_APP_TITLEIST"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y'"
                    ><b-img
                      style="width: 15px; margin-left: 13px;"
                      src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"
                    ></b-img
                  ></span>
                  <!-- </a> -->
                  <span
                    v-if="data.multi_course === 'Y' && home === false"
                    :class="tabledata['course_colour_R' + data.pft_round]"
                    class="multiDot-size-report"
                    >•</span
                  >
                  <span
                    v-if="showGender === 'Y' && home === false"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: tabledata.gender === 'F',
                      male: tabledata.gender === 'M'
                    }"
                    >•</span
                  >
                </td>
                <td
                  v-if="
                    tabledata.member_no !== 'Cat' &&
                      tabledata.pos !== 'CUT' &&
                      team === 'Y'
                  "
                  :title="tabledata.member_no"
                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                  class="NameLeft"
                >
                  {{ tabledata.name }}
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="sponsoredImage" :src="config.VUE_APP_TITLEIST"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y'"
                    ><b-img
                      style="width: 15px; margin-left: 13px;"
                      src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"
                    ></b-img
                  ></span>
                  <span
                    v-if="data.multi_course === 'Y' && home === false"
                    :class="tabledata['course_colour_R' + data.pft_round]"
                    class="multiDot-size-report"
                    >•</span
                  >
                  <span
                    v-if="showGender === 'Y' && home === false"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: tabledata.gender === 'F',
                      male: tabledata.gender === 'M'
                    }"
                    >•</span
                  >
                </td>
              </template>
              <template v-else>
                <td
                  v-if="
                    tabledata.member_no !== 'Cat' &&
                      tabledata.pos !== 'CUT' &&
                      team === 'N'
                  "
                  @click="playerCard(tabledata.id, index)"
                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                  class="NameLeft"
                >
                  <!-- <a :href="'/playerprofile/' + tabledata.member_no"> -->
                  <span
                    v-if="data.score_type === 'P' || data.stableford === 'N'"
                    class="outerPlayerName"
                  >
                    <span
                      v-if="data.team_event === 'Y' || data.bball_team == 'Y'"
                      class="PlayerName"
                    >
                      {{ tabledata.name }}
                    </span>
                    <span v-else class="PlayerName">
                    <template v-if="home == true && config.VUE_APP_ID_ASIAN_TOUR == 'apga' && config.VUE_APP_ID_ADT == 'adt'">
                        <template v-if="tabledata.profile == 'Y'">
                          <b-link :to="'/playerprofile/' + tabledata.member_no" class="removeUnderLineHome">
                            <span class="initialHome">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname.toLowerCase()}}</span>
                          </b-link>
                        </template>
                        <template v-else>
                          <span class="initialHomeNone">{{tabledata.initials}}</span> <span class="Cap">{{tabledata.surname.toLowerCase()}}</span>
                        </template>
                    </template>
                      <template v-else>
                        {{ tabledata.name }}
                      </template>
                    </span>
                    <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                  </span>
                  <span
                    v-if="data.score_type === 'P' || data.stableford === 'Y'"
                  >
                    {{ tabledata.name }}
                    <span v-if="tabledata.pro_ind === 'Am'"> (a)</span>
                  </span>
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="sponsoredImage" :src="config.VUE_APP_TITLEIST"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y'"
                    ><b-img
                      style="width: 15px; margin-left: 13px;"
                      src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"
                    ></b-img
                  ></span>
                  <!-- </a> -->
                  <span
                    v-if="data.multi_course === 'Y' && home === false"
                    :class="tabledata['course_colour_R' + data.pft_round]"
                    class="multiDot-size-report"
                    >•</span
                  >
                  <span
                    v-if="showGender === 'Y' && home === false"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: tabledata.gender === 'F',
                      male: tabledata.gender === 'M'
                    }"
                    >•</span
                  >
                </td>
                <td
                  v-if="
                    tabledata.member_no !== 'Cat' &&
                      tabledata.pos !== 'CUT' &&
                      team === 'Y'
                  "
                  @click="playerCard(tabledata.id, index)"
                  :class="{
                    'text-up': tabledata.posChang == 'up',
                    'text-down': tabledata.posChang == 'down'
                  }"
                  class="NameLeft"
                >
                  {{ tabledata.name }}
                  <span v-if="tabledata.sponsored === 'Y'"
                    ><b-img class="sponsoredImage" :src="config.VUE_APP_TITLEIST"></b-img
                  ></span>
                  <span v-if="tabledata.entry_sponsored === 'Y'"
                    ><b-img
                      style="width: 15px; margin-left: 13px;"
                      src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"
                    ></b-img
                  ></span>
                  <span
                    v-if="data.multi_course === 'Y' && home === false"
                    :class="tabledata['course_colour_R' + data.pft_round]"
                    class="multiDot-size-report"
                    >•</span
                  >
                  <span
                    v-if="showGender === 'Y' && home === false"
                    class="multiDot-size-reportgender"
                    :class="{
                      female: tabledata.gender === 'F',
                      male: tabledata.gender === 'M'
                    }"
                    >•</span
                  >
                </td>
              </template>
              <template v-if="tablePick === 'Score' || tablePick === 'Live'">
                <td class="mobHide mobnone" v-if="tabledata.pos !== 'CUT'" :class="{teamNat : title.includes('Team') && data.team_sb == 'Y'}">
                  <span v-if="tabledata.nationality === ''"></span>
                  <span v-else>
                    <template v-if="data.represents_flag_type === 'N'">
                      {{ tabledata.nationality }}
                    </template>
                    <template v-else>
                      <img
                        class="flag"
                        :src="
                          (config.VUE_APP_FLAG_URL + tabledata.nationality)
                            | lowercase
                        "
                      />
                    </template>
                  </span>
                </td>
              </template>
              <template
                v-if="data.score_type === 'P' || data.stableford === 'N'"
              >
                <td v-if="tabledata.vspar < 0" class="up">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.vspar > 0" class="down">
                  {{ tabledata.vspar }}
                </td>
                <td v-else-if="tabledata.pos !== 'CUT'"
                  :class="{
                    nonScore: tabledata.vspar == 'RTD',
                    nonScoreone: tabledata.vspar == 'DSQ',
                    nonScoretwo: tabledata.score == 'WDN',
                    nonScorethree: tabledata.score == 'DSQ',
                    nonScorefour: tabledata.score == 'RTD',
                    nonScorefive: tabledata.vspar == 'WDN'
                  }">
                  <span v-if="tabledata.vspar">
                    {{ tabledata.vspar }} 
                  </span>
                  <span v-else>
                    {{tabledata.score}}
                  </span>
                </td>
              </template>
              <template
                v-if="data.score_type === 'P' || data.stableford === 'Y'"
              >
                <td v-if="tabledata.pos !== 'CUT'">
                  <span v-if="data.scores_type == 'P'">{{ tabledata.score }}</span>
                  <span v-else-if="data.scores_type == 'G'">{{ tabledata["points_R" + data.pft_round] }}</span>
                </td>
              </template>
              <template
                v-if="
                  title.includes('Scoreboard') &&
                    tabledata.pos !== 'CUT' &&
                    home === false
                "
              >
                <td
                  v-for="(i, roundIt) in range(1, roundsPlayed)"
                  :key="roundIt"
                  class="mobnone"
                  v-show="is_qualifier == 'N' "
                >
                    <span
                      v-if="roundsPlayed === 1 && tabledata.vspar < 0"
                      class="up"
                      >{{ tabledata.score }}</span
                    >
                    <span
                      v-else-if="roundsPlayed === 1 && tabledata.vspar > 0"
                      class="down"
                      >{{ tabledata.score }}</span
                    >
                    <span v-else-if="roundsPlayed === 1">{{
                      tabledata.score
                    }}</span>
                    <span v-else-if="tabledata['vspar_R' + i] < 0" :class="up">{{
                      tabledata["score_R" + i]
                    }}</span>
                    <span
                      v-else-if="tabledata['vspar_R' + i] > 0"
                      :class="down"
                      >{{ tabledata["score_R" + i] }}</span
                    >
                    <span v-else
                      :class="{
                        nonScore: tabledata.vspar == 'RTD',
                        nonScoreone: tabledata.vspar == 'DSQ',
                        nonScoretwo: tabledata.vspar == 'WDN',
                        nonScorethree: tabledata['score_R' + i] == 'WDN',
                        nonScorefour: tabledata['score_R' + i] == 'DSQ',
                        nonScorefive: tabledata['score_R' + i] == 'RTD'
                      }"
                      class="par"
                    >{{ tabledata["score_R" + i] }}</span>
                </td>
                <template
                  v-if="tabledata.score_found === 'Y' && stableford == 'N'"
                >
                  <td v-if="tabledata.vspar < 0 && roundsPlayed > 1" class="up">
                    {{ tabledata.score }}
                  </td>
                  <td
                    v-else-if="tabledata.vspar > 0 && roundsPlayed > 1"
                    class="down"
                  >
                    {{ tabledata.score }}
                  </td>
                  <td v-else-if="roundsPlayed > 1">
                    {{ tabledata.score }}
                  </td>
                </template>
              </template>
              <template
                v-if="
                  data.round_head == 'Latest Scores' ||
                    (tabledata.score_found == 'N' && tabledata.pos !== 'CUT')
                "
              >
                <td v-if="tabledata.pos !== 'CUT'" style="color: #6c6c6c; font-weight:bold;" :class="{thruColumn : home == false}">
                  <template
                    v-if="tabledata.holes && tabledata.holes.length > 0"
                  >
                    <span v-show="tabledata.holes != '18'">{{
                      tabledata.holes
                    }}
                      <span v-if="tabledata['tee_R' + data.pft_round] > 1"
                        >*</span
                      >
                      <span v-if="data.rts[1] == 'S'" class="strokesColour">{{tabledata['strokes_R' + data.pft_round].split(",")[1]}}</span>
                    </span>
                    <span v-show="tabledata.holes == '18'">F</span>
                  </template>
                  <template v-else>
                    <span v-if="tabledata['score_R' + data.pft_round] == '' || tabledata['score_R' + data.pft_round] == 'RTD' && tabledata['score_R' + data.pft_round] == 'WDN' && tabledata['score_R' + data.pft_round] == 'DSQ'">
                      {{ tabledata["time_R" + data.pft_round] }}
                    </span>
                  </template>
                </td>
              </template>
              <template
                v-else-if="
                    (data.round_head.includes('Score') && tabledata.pos !== 'CUT')
                "
              >
                <td v-if="tabledata.pos !== 'CUT'" style="color: #6c6c6c; font-weight: bold" >
                  <template
                    v-if="tabledata.holes && tabledata.holes.length > 0"
                  >
                    <span v-show="tabledata.holes != '18'">{{
                      tabledata.holes
                    }}
                      <span v-if="tabledata['tee_R' + data.pft_round] > 1"
                        >*</span
                      >
                    </span>
                    <span v-show="tabledata.holes == '18'">F</span>
                  </template>
                  <template v-else-if="tabledata.score_found == 'Y' && data.tt_type != 'P'">
                     <span style="font-weight: bold"> {{ tabledata.score}}</span>
                      <!-- <td v-if="tabledata.vspar < 0 && roundsPlayed > 0" class="up">
                          {{ tabledata.score }}
                      </td>
                      <td
                        v-else-if="tabledata.vspar > 0 && roundsPlayed > 0"
                        class="down"
                      >
                        {{ tabledata.score }}
                      </td>
                      <td v-else-if="roundsPlayed > 0">
                        <span :class="{
                          nonScore: tabledata.vspar == 'RTD',
                          nonScoreone: tabledata.vspar == 'DSQ',
                          nonScoretwo: tabledata.score == 'WDN',
                          nonScorethree: tabledata.score == 'DSQ',
                          nonScorefour: tabledata.score == 'RTD'
                        }">
                          {{ tabledata.score }}
                        </span>
                      </td> -->
                    <!-- {{ tabledata["time_R" + data.pft_round] }} -->
                  </template>
                  <template v-else>
                    <span v-if="tabledata['score_R' + data.pft_round] == 'RTD' && tabledata['score_R' + data.pft_round] == 'WDN' && tabledata['score_R' + data.pft_round] == 'DSQ'">
                      {{ tabledata["time_R" + data.pft_round] }}
                    </span>
                  </template>
                </td>
              </template>
              <template v-if="home === false">
                <td
                  class="mobnone"
                  v-if="
                    tabledata.pos !== 'CUT'
                  "
                >
                  <template v-if="tabledata.profile == 'Y'">
                    <a
                      :href="'/playerprofile/' + tabledata.member_no"
                    >
                      <span class="playerInfo">
                        <!-- Player Info -->
                        <span class="iconRight">
                          <font-awesome-icon
                            class="icon"
                            :icon="['fa', 'chevron-right']"
                          />
                        </span>
                      </span>
                    </a>
                  </template>
                </td>
              </template>
            </template>
            <template
              v-if="
                (tablePick === 'Score' && data.match_play === 'Y') ||
                  (tablePick === 'Final' && data.match_play === 'Y')
              "
            >
              <td
                :title="tabledata.member_no_1"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                  win: tabledata.status_1 == 'W'
                }"
              >
                {{ tabledata.initials_1 }} {{ tabledata.surname_1 }}
              </td>
              <td v-if="tabledata.status_1 === 'W'" class="win">
                {{ tabledata.full_score_1 }}
              </td>
              <td v-else></td>
              <td>
                  <template
                    v-if="tabledata.holes && tabledata.holes.length > 0"
                  >
                    <span class="mobLevel" v-show="tabledata.holes != '18'"
                      >{{ tabledata.holes }} 
                      <span v-if="tabledata['tee_R' + data.pft_round] > 1"
                        >*</span
                      >
                      </span
                    >
                    <span v-show="tabledata.holes == '18'">F</span>
                  </template>
                  <template v-else>
                    {{ tabledata["time_R" + data.pft_round] }}
                  </template>
              </td>
              <td v-if="tabledata.status_2 === 'W'" class="win">
                {{ tabledata.full_score_2 }}
              </td>
              <td v-else></td>
              <td
                :title="tabledata.member_no_2"
                :class="{
                  'text-up': tabledata.posChang == 'up',
                  'text-down': tabledata.posChang == 'down',
                  win: tabledata.status_2 == 'W'
                }"
              >
                {{ tabledata.initials_2 }} {{ tabledata.surname_2 }}
              </td>
            </template>
          </tr>
          <template v-if="hide_score_card == 'N'">
            <tr
              @click.stop="rowClicked(rowClicked === -1)"
              v-if="index === clickedRow"
              class="tr-kids"
              :key="index + Math.random()"
            >
              <td id="reportCard" colspan="11">
                <PlayerReportCard
                  :playerData="playerData"
                  :playerDataTeam="playerDataTeam"
                  :data="data"
                  :config="config"
                  :actualRound="data.pft_round"
                  :roundsPlayed="data.pft_round"
                  :scoreType="data.scores_type"
                  :team="team"
                  :courses="courses"
                />
              </td>
            </tr>
          </template>

          <!-- <tr>
            <Ads />
          </tr> -->
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import Information from "@ocs-software/vue-ocs/ocs/reports/information.vue";
// import Ads from "@ocs-software/vue-ocs/ocs/reports/leaderBoardAds.vue";
// import apiCall from "@/services/api.js";
import PlayerReportCard from "../../scorecards/components/playerReportCard.vue";
export default {
  name: "score",
  props: [
    "tab",
    "data",
    "previousData",
    "develop",
    "home",
    "title",
    "season",
    "code",
    "tour",
    "team",
    "config",
    "match",
    "scoreFound",
    "showGender",
    "is_qualifier",
    "stableford",
    "showFav",
    "showmore",
    "show_info_web",
    "hide_score_card",
    "useName"
  ],
  components: { 
    PlayerReportCard,
    Information
  },
  data() {
    return {
      compare: [],
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      clickedRowCompare: -1,
      cardID: [],
      win: "win",
      polling: null,
      fanloggedIn: localStorage.getItem("FanLoggedIn"),
      playerFav: [],
      email_string: "",
      post_string: "",
      email: "",
      UserEmail: "",
      loginEmail: "",
      playerDataTeam: {},
    };
  },
  methods: {
    playerProfileLink() {},
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    rowClickedCompare: function(index) {
      if (this.home == true) {
        console.log("TRUE");
        this.clickedRowCompare = this.reportTitle;
      } else {
        if (
          this.tablePick === "Score" ||
          (this.tablePick === "Live" && this.clickedRowCompare !== index)
        )
          this.clickedRowCompare = index;
        else this.clickedRowCompare = -1;
      }
    },
    rowClicked: function(index) {
      if (this.home == true) {
        console.log("TRUE");
        this.clickedRow = this.reportTitle;
      } else {
        if (
          (this.tablePick === "Score" || this.tablePick === "Live") && this.clickedRow !== index
        )
          this.clickedRow = index;
        else this.clickedRow = -1;
      }
    },

    playerCard: function(playerNo, index) {
      var playerData = {};
      // var cardID = event.target.getAttribute("title");
      console.log("playerData");
      console.log(playerData);
      var cardID = playerNo;
      console.log("cardID");
      console.log(cardID);
      for (var i of this.data.scores.scores_entry) {
        console.log("in scores");
        if (i.member_no == playerNo) {
          this.playerData = i;
          console.log("playerData 998");
          console.log(this.playerData);
          break;
        }
      }
      for (var t of this.data.team_scores.team_scores_entry) {
        console.log("in scores");
        if (t.member_no == playerNo) {
          this.playerDataTeam = t;
          console.log("playerData 998");
          console.log(this.playerDataTeam);
          break;
        }
      }
      this.rowClicked(index);
      // return (
      //   (this.cardID = cardID),
      //   apiCall
      //     .playercard(this.data.season, this.code, this.cardID)
      //     .then(({ data }) => {
      //       this.playerCardData = data;
      //       if (Array.isArray(this.data.courses.courses_entry)) {
      //         this.courses = this.data.courses.courses_entry
      //         console.log('One')
      //       } else {
      //         this.courses = [this.data.courses.courses_entry]
      //         console.log('Two')
      //       }
      //       this.loading = false;
      //     })
      //     .catch(error => {
      //       console.log(error);
      //       throw error;
      //     })
      // );
    },
    ppC: function(playerNo) {
      // var cardID = event.target.getAttribute("title");
      var cardID = playerNo;
      console.log("cardID");
      console.log(cardID);
    },
    SelectFan: function() {
      let post_string = localStorage.getItem("Email");
      axios
        .post(
          this.config.VUE_APP_FAN_MARKETING_URL +
            "tour=" +
            this.config.VUE_APP_FAN_DATA_BASE +
            "&action=select&" +
            localStorage.getItem("Email") +
            "access_key=" +
            this.config.VUE_APP_FAN_KEY +
            "&mc_host=" +
            this.config.VUE_APP_FAN_MC_HOST,
          post_string,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        )
        .then(response => {
          this.loginEmail =
            response.data.user[
              "users_" + this.config.VUE_APP_FAN_DATA_BASE + "-email"
            ];
          this.initalFanData = response.data.fields.field;
        });
    },
    saveFav: function(playerID) {
      var playernum = playerID;
      let EmailKey = localStorage.getItem("EmailKey");
      const dbse = this.config.VUE_APP_FAN_DATA_BASE;
      const formData = [
        { table: "interests_" + dbse, name: "email", value: this.loginEmail },
        { table: "interests_" + dbse, name: "id", value: playernum },
        { table: "interests_" + dbse, name: "type", value: "PLAYER" }
      ];
      console.log("formData");
      console.log(formData);
      let post_string = "";

      for (let i = 0; i < formData.length; i++) {
        post_string += "fields[" + i + "][table]=" + formData[i].table + "&";
        post_string += "fields[" + i + "][name]=" + formData[i].name + "&";
        post_string += "fields[" + i + "][value]=" + formData[i].value + "&";
      }
      this.email_string = "email=" + EmailKey + "&";
      post_string += this.email_string;
      console.log("post_string");
      console.log(post_string);
      axios
        .post(
          this.config.VUE_APP_FAN_MARKETING_URL +
            "tour=" +
            this.config.VUE_APP_FAN_DATA_BASE +
            "&action=edit_user&" +
            post_string +
            "access_key=" +
            this.config.VUE_APP_FAN_KEY +
            "&mc_host=" +
            this.config.VUE_APP_FAN_MC_HOST,
          post_string,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        )
        .then(response => {
          this.loginForename =
            response.data.user[
              "users_" + this.config.VUE_APP_FAN_DATA_BASE + "-forename"
            ];
          // this.updatedfavplayer = response.data.user.interests.interest;
          // localStorage.setItem("favPlayers",  JSON.stringify(this.updatedfavplayer));
          this.SelectFan();
        });
    }
  },
  mounted() {
    this.SelectFan();
  },
  computed: {
    teamEvent: function(team) {
      var array = this.data;
      if (array["team_scores"] !== undefined) team = "Y";
      else team = "N";
      return team;
    },
    tablePick: function(picked) {
      if (this.title === "Tournament Entries") picked = "Entries";
      else if (this.title.includes("Draw")) picked = "Draw";
      else if (
        (this.title.includes("Scores") && this.data.live_scoring === "N") ||
        (this.title.includes("Scoreboard") && this.data.live_scoring === "N")
      )
        picked = "Score";
      else if (
        (this.title.includes("Scores") && this.data.live_scoring === "Y") ||
        (this.title.includes("Scoreboard") && this.data.live_scoring === "Y")
      )
        picked = "Live";
      else if (this.title.includes("Final")) picked = "Final";
      else if (this.title.includes("Live")) picked = "Live";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    Eds(reportData) {
      if (this.home === false) {
        if (
          (this.title.includes("Scores") && this.team === "N") ||
          (this.title.includes("Scoreboard") && this.team === "N") ||
          (this.title.includes("Live") && this.team === "N")
        )
          if (Array.isArray(this.data.scores.scores_entry)) {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt' && this.$route.name == 'tournament') {
              if (this.showmore == false) {
                reportData = this.data.scores.scores_entry.slice(0,10);
              } else {
                reportData = this.data.scores.scores_entry;
              }
            } else {
              reportData = this.data.scores.scores_entry;
            }
            // console.log('One')
          } else {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt' && this.$route.name == 'tournament') {
              if (this.showmore == false) {
                reportData = [this.data.scores.scores_entry].slice(0,10);
              } else {
                reportData = [this.data.scores.scores_entry];
              }
            } else {
              reportData = [this.data.scores.scores_entry];
            }
            // console.log('Two')
          }
        else if (
          (this.title.includes("Scores") && this.team === "Y") ||
          (this.title.includes("Scoreboard") && this.team === "Y") ||
          (this.title.includes("Live") && this.team === "Y")
        )
          if (Array.isArray(this.data.team_scores.team_scores_entry)) {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt' && this.$route.name == 'tournament') {
              if (this.showmore == false) {
                reportData = this.data.team_scores.team_scores_entry.slice(0,10);
              } else {
                reportData = this.data.team_scores.team_scores_entry;
              }
            } else {
              reportData = this.data.team_scores.team_scores_entry;
            }
            // console.log('One')
          } else {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt' && this.$route.name == 'tournament') {
              if (this.showmore == false) {
                reportData = [this.data.team_scores.team_scores_entry].slice(0,10); 
              } else {
                reportData = [this.data.team_scores.team_scores_entry];  
              }
            } else {
              reportData = [this.data.team_scores.team_scores_entry];
            }
            // console.log('Two')
          }
        return reportData;
      } else {
        if (
          this.title.includes("Scores") ||
          this.title.includes("Scoreboard") ||
          this.title.includes("Live")
        )
          if (this.team === "N") {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt') {
              if (Array.isArray(this.data.scores.scores_entry)) {
                reportData = this.data.scores.scores_entry;
              } else {
                reportData = [this.data.scores.scores_entry];
              }
            } else {
              if (Array.isArray(this.data.scores.scores_entry)) {
                reportData = this.data.scores.scores_entry.slice(0, 7);
              } else {
                reportData = [this.data.scores.scores_entry].slice(0, 7);
              }
            }
          } else {
            if (this.config.VUE_APP_ID_ASIAN_TOUR == 'apga' && this.config.VUE_APP_ID_ADT == 'adt') {
              if (Array.isArray(this.data.team_scores.team_scores_entry)) {
                reportData = this.data.team_scores.team_scores_entry;
              } else {
                reportData = [this.data.team_scores.team_scores_entry];
              }
            } else {
              if (Array.isArray(this.data.team_scores.team_scores_entry)) {
                reportData = this.data.team_scores.team_scores_entry.slice(0, 7);
              } else {
                reportData = [this.data.team_scores.team_scores_entry].slice(0,6);
              }
            }
          }
        return reportData;
      }
    },
    Compare(reportData) {
      if (this.home === false) {
        if (
          (this.title.includes("Scores") && this.team === "N") ||
          (this.title.includes("Scoreboard") && this.team === "N") ||
          (this.title.includes("Live") && this.team === "N")
        )
          if (Array.isArray(this.data.scores.scores_entry)) {
            reportData = this.data.scores.scores_entry;
            // console.log('One')
          } else {
            reportData = [this.data.scores.scores_entry];
            // console.log('Two')
          }
        else if (
          (this.title.includes("Scores") && this.team === "Y") ||
          (this.title.includes("Scoreboard") && this.team === "Y") ||
          (this.title.includes("Live") && this.team === "Y")
        )
          if (Array.isArray(this.data.team_scores.team_scores_entry)) {
            reportData = this.data.team_scores.team_scores_entry;
            // console.log('One')
          } else {
            reportData = [this.data.team_scores.team_scores_entry];
            // console.log('Two')
          }
        return reportData;
      } else {
        if (
          this.title.includes("Scores") ||
          this.title.includes("Scoreboard") ||
          (this.title.includes("Live") && this.team === "N")
        )
          if (Array.isArray(this.data.scores.scores_entry)) {
            // reportData = this.data.scores.scores_entry.slice(0, 6);
            reportData = this.data.scores.scores_entry.slice(0, 7);
            // console.log('One')
          } else {
            reportData = [this.data.scores.scores_entry].slice(0, 7);
            // console.log('Two')
          }
        else if (
          (this.title.includes("Scores") && this.team === "Y") ||
          (this.title.includes("Scoreboard") && this.team === "Y") ||
          (this.title.includes("Live") && this.team === "Y")
        )
          if (Array.isArray(this.data.team_scores.team_scores_entry)) {
            // reportData = this.data.team_scores.team_scores_entry.slice(0, 6);
            reportData = this.data.team_scores.team_scores_entry.slice(0, 7);
            console.log("Team Data");
          } else {
            reportData = [this.data.team_scores.team_scores_entry].slice(0, 7);
            console.log("Team Data Two");
          }
        return reportData;
      }
    }
  },
  watch: {
    Eds(newValue, oldValue) {
      newValue.forEach((value1, key1) => {
        oldValue.forEach((value2, key2) => {
          if (value1.id === value2.id) {
            if (key1 < key2) {
              value1.posChang = "up";
            } else if (key1 > key2) {
              value1.posChang = "down";
            }
          }
        });
      });

      // console.log(newValue);
    },
    Compare(newValue, oldValue) {
      newValue.forEach((value1, key1) => {
        oldValue.forEach((value2, key2) => {
          if (value1.id === value2.id) {
            if (key1 < key2) {
              value1.posChang = "up";
            } else if (key1 > key2) {
              value1.posChang = "down";
            }
          }
        });
      });

      // console.log(newValue);
    },
    immediate: true,
    deep: true
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    }
  }
  // created() {
  //   this.polling = setInterval(() => {
  //     console.log("Run refresh two");
  //     this.watch();
  //     console.log("this.watch")
  //     console.log(this.watch())
  //   }, 120000);
  // },
};
</script>
<style>
th.hideOnMob.redPlayoff {
  background-color: red;
}
</style>
